import CompraCrud from './CompraCrud'
export {CompraCrud}
export default CompraCrud
